export default function AyupathCard({ children }) {
  return (
    <div className="w-full max-w-md mx-auto rounded-3xl border border-gray-200 bg-white shadow-lg">
      <div className="p-6 sm:p-7">{children}</div>
    </div>
  );
}
